import type { BasketOrder, BasketTradingState } from 'src/routes/widgets/BasketTradingWidget/state/types';

export type InitializeStateAction = {
    type: 'INITIALIZE_STATE';
    payload?: {
        account: string;
    };
};
export const initializeState = (payload?: InitializeStateAction['payload']): InitializeStateAction => ({
    type: 'INITIALIZE_STATE',
    payload,
});

export type SetBasketTypeAction = {
    type: 'SET_BASKET_TYPE';
    value: BasketTradingState['type'];
};
export const setBasketType = (value: BasketTradingState['type']): SetBasketTypeAction => ({
    type: 'SET_BASKET_TYPE',
    value,
});

export type SetBasketLabelAction = {
    type: 'SET_BASKET_LABEL';
    value: BasketTradingState['label'];
};
export const setBasketLabel = (value: BasketTradingState['label']): SetBasketLabelAction => ({
    type: 'SET_BASKET_LABEL',
    value,
});

export type SetDefaultsAction = {
    type: 'SET_DEFAULTS';
    value: BasketTradingState['defaults'];
};
export const setDefaults = (value: BasketTradingState['defaults']): SetDefaultsAction => ({
    type: 'SET_DEFAULTS',
    value,
});

export type ResetBasketAction = {
    type: 'RESET_BASKET';
};
export const resetBasket = (): ResetBasketAction => ({
    type: 'RESET_BASKET',
});

export type AddOrderAction = {
    type: 'ADD_ORDER';
    order: BasketOrder;
};
export const addOrder = (order: BasketOrder): AddOrderAction => ({
    type: 'ADD_ORDER',
    order,
});

export type AddOrdersBatchAction = {
    type: 'ADD_ORDERS_BATCH';
    orders: BasketOrder[];
};
export const addOrdersBatch = (orders: BasketOrder[]): AddOrdersBatchAction => ({
    type: 'ADD_ORDERS_BATCH',
    orders,
});

export type RemoveOrderAction = {
    type: 'REMOVE_ORDER';
    order: BasketOrder;
};
export const removeOrder = (order: BasketOrder): RemoveOrderAction => ({
    type: 'REMOVE_ORDER',
    order,
});

export type UpdateOrderAction = {
    type: 'UPDATE_ORDER';
    order: BasketOrder;
};
export const updateOrder = (order: BasketOrder): UpdateOrderAction => ({
    type: 'UPDATE_ORDER',
    order,
});

export type RedistributeWeightsAction = {
    type: 'REDISTRIBUTE_WEIGHTS';
};
export const redistributeWeights = (): RedistributeWeightsAction => ({
    type: 'REDISTRIBUTE_WEIGHTS',
});

export type SetWeightBasisAction = {
    type: 'SET_WEIGHT_BASIS';
    value: 'equal' | 'custom';
};
export const setWeightBasis = (value: 'equal' | 'custom'): SetWeightBasisAction => ({
    type: 'SET_WEIGHT_BASIS',
    value,
});

export type SetNotionalAmountAction = {
    type: 'SET_NOTIONAL_AMOUNT';
    value: number | undefined;
};
export const setNotionalAmount = (value: number | undefined): SetNotionalAmountAction => ({
    type: 'SET_NOTIONAL_AMOUNT',
    value,
});

export type SetNotionalTypeAction = {
    type: 'SET_NOTIONAL_TYPE';
    value: 'net' | 'gross';
};
export const setNotionalType = (value: 'net' | 'gross'): SetNotionalTypeAction => ({
    type: 'SET_NOTIONAL_TYPE',
    value,
});

export type SetPositionsAccountAction = {
    type: 'SET_POSITIONS_ACCOUNT';
    value: string | undefined;
};
export const setPositionsAccount = (value: string | undefined): SetPositionsAccountAction => ({
    type: 'SET_POSITIONS_ACCOUNT',
    value,
});

export type BasketTradingAction =
    | InitializeStateAction
    | SetBasketTypeAction
    | SetBasketLabelAction
    | SetDefaultsAction
    | ResetBasketAction
    | AddOrderAction
    | AddOrdersBatchAction
    | RemoveOrderAction
    | UpdateOrderAction
    | RedistributeWeightsAction
    | SetWeightBasisAction
    | SetNotionalAmountAction
    | SetNotionalTypeAction
    | SetPositionsAccountAction;
